module.exports = __webpack_public_path__ + "img/4.e738a525.jpg";